import React from 'react';

export default function InfoColumns() {
    return (
        <section className="info-columns" aria-label="About and mission">
            <div className="info-inner">
                <div className="col">
                    <h3 className="info-heading">අරමුණු</h3>
                    <ul className="info-list">
                        <li>උචිත තාක්ෂණයන ප්‍රචලිත කිරීමෙන් බෝගවල නිෂ්පාදනය හා ඵලදායිතාවය ඉහල නැංවීම</li>
                        <li>උසස් තත්වයේ කෘෂිකාර්මික රෝපණ ද්‍රව්‍ය නිෂ්පාදනය හා බෙදා හැරීම</li>
                        <li>ජනතාව සදහා පුහුණු වැඩසටහන් පැවැත්වීම මගින්,කුසලතා හා ආකල්ප වැඩිදියුණු කිරීම</li>
                        <li>දෙපාර්තුමේන්තුවේ නිලධාරීන්ගේ ධාරිතා සංවර්ධනය මගින් කාර්යක්ෂමතාවය ඉහල නැංවීම</li>
                    </ul>
                </div>

                <div className="col">
                    <h3 className="info-heading">දැක්ම</h3>
                    <p className="info-text">ආහාර සුරක්ෂිතතාවයෙන් යුත් ස්වයංපෝෂිත සබරගමු පළාතක්.</p>
                </div>

                <div className="col">
                    <h3 className="info-heading">මෙහෙවර</h3>
                    <p className="info-text">තිරසාර කෘෂිකර්ම සංවර්ධනයක් තුලින් පළාතේ ජනතාවගේ ජීවන තත්වය ඉහල නැංවීම.</p>
                </div>
            </div>
        </section>
    );
}
